/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'minus': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs><path pid="0" d="M8 11c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1H8zm4-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" id="svgicon_minus_a"/></defs><use _fill="#004CD0" xlink:href="#svgicon_minus_a" transform="translate(-2 -2)" fill-rule="evenodd"/>'
  }
})
